import React, { useContext } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useHistory } from "react-router";
import cn from "classnames";
import { dataStore } from "../../../contexts/DataContext";
import { getModuleById } from "../../../utils/dataRetrieval";
import ModuleMap, {
    moduleMapMessages,
} from "../../../components/ModuleMap/ModuleMap";
import VisuallyHidden from "../../../components/VisuallyHidden/VisuallyHidden";

import "./ModuleCard.scss";

const ModuleCard: React.FC<{
    moduleId: string;
    diagnosis?: {
        progression: number;
        averageScore: number;
    };
}> = ({ moduleId, diagnosis }) => {
    const { data } = useContext(dataStore);
    const history = useHistory();
    const intl = useIntl();

    const module = getModuleById(moduleId, data);

    return (
        <div className="student-module-card">
            <div className="title-container">
                {module.studentPath && (
                    <div className="student-path__placeholder"></div>
                )}

                <div
                    className={cn("title", { active: diagnosis?.progression })}
                >
                    {module.title.short ?? ""}
                </div>

                {module.studentPath && (
                    <ModuleMap
                        module={module}
                        btnLabel={
                            <VisuallyHidden>
                                {intl.formatMessage(
                                    moduleMapMessages.studentBtnLabel
                                )}
                            </VisuallyHidden>
                        }
                        modalTitle={intl.formatMessage(
                            moduleMapMessages.studentModalTitle
                        )}
                    />
                )}
            </div>

            <div className="card-content">
                <div className="bar-container">
                    <div
                        className={`bar ${
                            diagnosis?.progression ? "progress-active" : ""
                        }`}
                    >
                        <div
                            className="progress-bar"
                            style={{
                                width: `${diagnosis?.progression ?? 0}%`,
                            }}
                        >
                            <div className="text-content">
                                {intl.formatMessage(messages.progression)}
                            </div>
                        </div>
                    </div>
                    {diagnosis && !isNaN(diagnosis.averageScore) ? (
                        <div className="bar success-rate-active">
                            <div className="text-content">
                                {intl.formatMessage(messages.successRate)}
                            </div>
                            <span>{`${diagnosis.averageScore}%`}</span>
                        </div>
                    ) : (
                        <div className="bar">
                            <div className="text-content">
                                {intl.formatMessage(messages.successRate)}
                            </div>
                        </div>
                    )}
                </div>
                <div className="card-modal">
                    <button
                        data-key={moduleId}
                        onClick={() => {
                            history.push("/player/" + moduleId);
                        }}
                        className="btn-modal"
                        disabled={diagnosis?.progression === 100}
                    >
                        {diagnosis?.progression === 0
                            ? intl.formatMessage(messages.start)
                            : diagnosis?.progression === 100
                            ? intl.formatMessage(messages.moduleCompleted)
                            : intl.formatMessage(messages.continue)}
                    </button>
                </div>
            </div>
        </div>
    );
};

const messages = defineMessages({
    progression: {
        id: "moduleList-student-progression",
        defaultMessage: "Progression",
    },
    successRate: {
        id: "moduleList-student-successRate",
        defaultMessage: "Success rate",
    },
    start: {
        id: "moduleList-student-start",
        defaultMessage: "Start",
    },
    moduleCompleted: {
        id: "moduleList-student-completedModule",
        defaultMessage: "Module completed",
    },
    continue: {
        id: "moduleList-student-continue",
        defaultMessage: "Continue",
    },
});

export default ModuleCard;
